import {zodResolver} from '@hookform/resolvers/zod';
import type {ConfirmSignUpInput} from '@aws-amplify/auth';
import {PinInput} from '@mantine/core';
import {Stack} from 'src/design/atoms/Stack';
import {Text} from 'src/design/atoms/Text';
import React from 'react';
import {Controller, useForm} from 'react-hook-form';
import {SubmitButton} from 'src/design/molecules/SubmitButton';
import {useAppDispatch, useAppSelector} from 'src/redux/hooks';
import {confirmSignUpUser} from 'src/redux/slices/authSlice';
import {z} from 'zod';

const schema = z.object({
  confirmationCode: z
    .string()
    .length(6, {message: 'Confirmation code should be 6 characters.'}),
});

type FormValues = z.infer<typeof schema>;

export const ConfirmSignUp: React.FC = () => {
  const {username} = useAppSelector(state => state.auth);
  const dispatch = useAppDispatch();

  const {control, handleSubmit: handleFormSubmit} = useForm<FormValues>({
    defaultValues: {
      confirmationCode: '',
    },
    resolver: zodResolver(schema),
  });

  function handleSubmit(values: FormValues): void {
    const input = {
      username: username,
      confirmationCode: values.confirmationCode,
    } as ConfirmSignUpInput;

    void dispatch(confirmSignUpUser(input));
  }

  return (
    <>
      <form onSubmit={handleFormSubmit(handleSubmit)}>
        <Stack align="center">
          <Text mb="lg">
            A confirmation code has been sent to your email. Please enter it
            below to continue.
          </Text>
          <Controller
            name="confirmationCode"
            control={control}
            render={({field, fieldState}) => (
              <PinInput
                length={6}
                {...field}
                error={!!fieldState.error}
                mb="lg"
              />
            )}
          />
          <SubmitButton>Continue</SubmitButton>
        </Stack>
      </form>
    </>
  );
};
